exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-inline[data-v-c39ac61c] {\n  display: inline-block;\n  width: 350px;\n}\n.batch-filter[data-v-c39ac61c] {\n  padding-top: 5px !important;\n}\n", ""]);

// exports
